import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import formStyles from '@assets/scss/components/form.module.scss'
import { SearchIcon } from '@shared-components/ctIcons'

const CustomInput = dynamic(() => import('@shared/components/customForm/customInput'))
const CustomFormGroup = dynamic(() => import('@shared/components/customForm/customFormGroup'))

const CustomSearch = ({ className, inputClass = '', ...rest }) => {
  return (
    <CustomFormGroup className={`${formStyles.formGroup} ${styles.searchGroup} position-relative ${className}`} controlId="search">
      <CustomInput
        type="text"
        name="search"
        className={`${formStyles.formControl} ${styles.searchControl} ${inputClass} rounded-pill`}
        {...rest}
      />
      <div className={`${styles.searchIcon} position-absolute top-50 translate-middle-y`}>
        <SearchIcon />
      </div>
    </CustomFormGroup>
  )
}

CustomSearch.propTypes = {
  className: PropTypes.any,
  inputClass: PropTypes.string
}

export default CustomSearch
